export const itemsBaseApiPath = '/api/common/products';
import { apiHelperGenerators } from '@/shared';
const {
  fetchItemsGen,
  deleteItemGen,
  getItemByIdGen,
  editItemGen,
  addItemGen
} = apiHelperGenerators;

export const fetchItems = fetchItemsGen(itemsBaseApiPath, 'listItems');
export const deleteItem = deleteItemGen(itemsBaseApiPath);
export const getItemById = getItemByIdGen(itemsBaseApiPath);
export const addItem = addItemGen(itemsBaseApiPath);
export const editItem = editItemGen(itemsBaseApiPath, 'put');

export default {
  fetchItems,
  deleteItem,
  getItemById,
  addItem,
  editItem
};
